<template>
  <div class="">
    <vs-popup
      type="filled"
      pazaryer
      title="Sipariş Detay"
      :active.sync="popupKartDetay"
    >
      <div id="invoice-page">
        <div class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button
              @click="yazdir()"
              class="mb-base mr-3"
              type="border"
              icon-pack="feather"
              icon="icon icon-download"
              >İndir/Yazdır</vs-button
            >
          </div>
        </div>
        <div id="printMe2">
          <vx-card id="invoice-container" style="padding: 25px">
            <!-- INVOICE METADATA -->
            <table style="width: 100%" class="border-collapse">
              <tr>
                <td class="p-2">
                  <h6>{{ program }}</h6>
                </td>
                <td style="padding: 10px; text-align: right">
                  <h6>Sipariş Numarası</h6>
                  <p>{{ orderNumber }}</p>
                  <h6>Fatura Tarihi:</h6>
                  <p>{{ getNow() }}</p>
                </td>
              </tr>
            </table>

            <br />
            <table style="width: 100%" class="border-collapse">
              <tr>
                <td
                  style="
                    width: 50%;
                    padding-top: 25px;
                    text-align: center;
                    padding-bottom: 25px;
                    border: solid;
                  "
                >
                  <div style="padding-bottom: 25px">
                    <h6>Teslimat Adresi | {{ shipFullName }}</h6>
                    <p>{{ shipFullAddress }}</p>
                    <p>{{ shipDistrict }} / {{ shipCity }}</p>
                    <p>{{ telefon }}</p>
                    <p>{{ customerEmail }}</p>
                  </div>
                </td>
                <td
                  style="
                    width: 50%;
                    padding-top: 25px;
                    text-align: center;
                    padding-bottom: 25px;
                    border: solid;
                  "
                >
                  <h6>Fatura Adresi | {{ invoiceFullName }}</h6>
                  <p>{{ invoiceFullAddress }}</p>
                  <p>{{ invoiceDistrict }} / {{ invoiceCity }}</p>
                  <p>{{ telefon }}</p>
                  <p>{{ customerEmail }}</p>
                </td>
              </tr>
            </table>

            <br />
            <br />
            <table
              style="border-top: 1px solid grey; width: 100%"
              class="border-collapse"
            >
              <tr>
                <td>
                  <table style="width: 100% !important; text-align: center">
                    <tr>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        Stok Kodu
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        BARKOD
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ÜRÜN ADI
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ÜRÜN FİYATI
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ADET
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        TUTAR
                      </th>
                    </tr>

                    <tr :key="indextr" v-for="(tr, indextr) in productDetail">
                      <td style="padding: 8px">
                        {{ tr.merchantSku }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.barcode }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.productName }}
                      </td>
                      <td style="padding: 8px; text-align: right">
                        {{ (tr.price / tr.quantity).toFixed(2) }} TL
                      </td>
                      <td style="padding: 8px">{{ tr.quantity }} adet</td>
                      <td style="padding: 8px; text-align: right">
                        {{ tr.price.toFixed(2) }} TL
                      </td>
                    </tr>

                    <tr>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td
                        style="
                          font-weight: bold;
                          border-top: 1px solid grey;
                          border-bottom: 1px solid grey;
                          border-left: 1px solid grey;
                          padding: 8px;
                        "
                      >
                        Toplam Tutar:
                      </td>
                      <td
                        style="
                          font-weight: bold;
                          border-top: 1px solid grey;
                          text-align: right;
                          border-bottom: 1px solid grey;
                          border-right: 1px solid grey;
                          padding: 8px;
                        "
                      >
                        {{ totalPrice.toFixed(2) }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <br />
            </table>

            <br />
            <table style="width: 100%" class="border-collapse">
              <tr>
                <v-barcode v-bind:value="barcodeValue" font-options="bold">
                </v-barcode>
              </tr>
              <tr>
                <td>
                  <h6>{{ cargoProviderName }} | {{ cargoTrackingNumber }}</h6>
                </td>
                <td></td>
                <td class="p-2">
                  {{ serialNumber }}
                </td>
              </tr>
            </table>

            <br />

            <!-- INVOICE FOOTER -->
          </vx-card>

          <vx-card id="invoice-container">
            <br />

            <br />
            <!-- INVOICE METADATA -->
            <table style="width: 100%" class="border-collapse">
              <tr>
                <td></td>
              </tr>
            </table>

            <br />

            <!-- INVOICE FOOTER -->
          </vx-card>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
//import { defineComponent } from "@vue/composition-api";
import VueBarcode from "vue-barcode";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import { fixTurkishCharsDeep } from "../../../../helpers/fixTurkishChars";
export default {
  name: "SiparisDetayButton",
  props: [],
  //[ pazaryerData=[], "orderNumber", "invoiceFirstName", "invoiceLastName", "shipFullName"],

  data() {
    return {
      barcodeValue: "",
      orderNumber: "",
      program: "",
      productDetail: [],

      shipFullAddress: "",
      shipFullName: "",
      shipCity: "",
      shipDistrict: "",

      quantityPrice: 0,
      grossAmount: 0,
      totalDiscount: 0,
      totalPrice: 0,

      invoiceFullAddress: "",
      invoiceFullName: "",
      telefon: 0,
      customerEmail: "",

      cargoProviderName: "",
      cargoTrackingNumber: "",
      discount: 0,

      mailTo: "",
      invoiceDistrict: "",
      invoiceCity: "",

      viewCheck: false,
      popupKartDetay: false,
      musteriId: "",
      imageSrc: "",
      serialNumber: "",
    };
  },
  created() {
    this.musteriId = Store.state.MusteriId;
    console.log(this.musteriId);
    // this.imageSrc = "../../assets/images/logo/" + this.musteriId + ".png";
    //  console.log(this.imageSrc);
  },
  methods: {
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe2");
    } /*
    findLogo() {
      return require("../../../../assets/images/logo/" +
        this.musteriId +
        ".png");
    },*/,
    yazdir() {
      setTimeout(this.yazdirBekle, 5000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe2");
    },
    getNow: function () {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },
    printInvoice() {
      window.print();
    },

    siparisDetayCek(productValue) {
      var vm = this;
      vm.productDetail = [];
      vm.totalPrice = 0;
      vm.quantityPrice = 0;
      vm.popupKartDetay = true;
      console.log(productValue[0]);

      vm.cargoProviderName = productValue[0].cargoProviderName;
      vm.cargoTrackingNumber = productValue[0].cargoTrackingNumber.trim();
      vm.barcodeValue = vm.cargoTrackingNumber;
      vm.orderNumber = productValue[0].orderNumber;
      vm.program = productValue[0].program;
      vm.shipFullAddress = productValue[0].shipFullAddress;
      vm.shipFullName = productValue[0].shipFullName;
      vm.shipCity = productValue[0].shipCity;
      vm.shipDistrict = productValue[0].shipDistrict;
      vm.grossAmount = productValue[0].grossAmount;
      vm.totalDiscount = productValue[0].totalDiscount;
      //  vm.totalPrice = productValue[0].TOTAL;
      vm.invoiceFullAddress = productValue[0].invoiceFullAddress;
      vm.invoiceDistrict = productValue[0].invoiceDistrict;
      vm.invoiceCity = productValue[0].invoiceCity;
      vm.serialNumber = productValue[0].order_Id;

      if (productValue[0].program != "Trendyol") {
        vm.telefon = productValue[0].telefon;
        vm.customerEmail = productValue[0].customerEmail;
      } else {
        vm.telefon = "";
        vm.customerEmail = "";
      }

      vm.invoiceFullName = productValue[0].invoiceFullName;
      vm.discount = productValue[0].discount;

      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: productValue[0].program,
        orderNumber: productValue[0].orderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.SiparisDetay(args, function (err, result) {
          if (result.SiparisDetayResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = fixTurkishCharsDeep(JSON.parse(result.SiparisDetayResult));
          console.log("SiparisDetay");
          console.log(vm.veriler);

          vm.veriler.forEach((value, i) => {
            vm.productDetail.push({
              barcode: value.barcode,
              productCode: value.productCode,
              merchantSku: value.merchantSku,
              productName: value.productName,
              quantity: value.quantity,
              price: value.price,
              amount: value.amount,
            });
            if (vm.productDetail[i].quantity > 1) {
              for (
                let index = 0;
                index < vm.productDetail[i].quantity;
                index++
              ) {
                vm.quantityPrice += vm.productDetail[i].price;
              }
            } else {
              vm.quantityPrice = vm.productDetail[i].price;
            }
            vm.totalPrice += value.price;
            //    console.log(value.price * value.quantity);
          });
        });
      });
    },
  },

  components: {
    "v-barcode": VueBarcode,
  },
  mounted() {
    this.$emit("setAppClasses", "invoice-page");
  },
  // mounted(){this.siparisDetay()}
};
</script>
<style lang="scss">
.con-vs-popup .vs-popup {
  width: 850px;
}
.vs-table--tbody-table {
  min-width: 0px;
}
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>
